import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.section`
	padding: 20px 0 0;

	${minWidth('tablet')} {
		padding: 112px 0 0;
	}
`;

export const DeviceImage = styled.img`
	width: 100%;
	${minWidth('tablet')} {
		height: auto;
		width: 75%;
	}
`;

export const ContentColumn = styled.div`
	order: -1;

	${minWidth('tablet')} {
		order: 2;
		padding-top: 20px;
	}
`;

export const Heading = styled.h3`
	color: ${palette('gray7')};
	font-size: 24px;
	${fontWeight(FontWeights.Medium)}
	margin-bottom: 16px;

	${minWidth('tablet')} {
		font-size: 40.5px;
	}
`;

export const BodyText = styled.div`
	color: ${palette('gray7')};
	font-size: 20px;
	margin-bottom: 48px;
`;

export const StyledButton = styled(Button)`
	max-width: 335px;
`;

export const ButtonWrapper = styled.div`
	margin: 0 auto 36px;
	width: calc(100% - 32px);

	${minWidth('tablet')} {
		margin: 0;
		width: auto;
	}
`;
